export default __webpack_public_path__ + "static/media/Airbnb3.5d8d2e3a.png";